import api from "api";
import Footer from "components/corporate/footer";
import Header from "components/header";
import { RootState } from "types";
import Login from "pages/app/login";
import { useDispatch, useSelector } from "react-redux";
import { Route as DOMRoute } from "react-router-dom";
import { actions } from "redux/reducers";

function Route({ path = "", validateToken = false, isPublic = false, showSidenav = true, showHeader = true, exact = false, ...props }) {
    if (localStorage.AccessToken === undefined) {
        localStorage.removeItem("AccessToken");
        localStorage.removeItem("persist:root");
    }
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.user);

    if (!user && validateToken) {
        if (!localStorage.AccessToken) {
            return (
                <DOMRoute path={path} exact={exact}>
                    <Login />
                </DOMRoute>
            );
        } else {
            api.user.get().then((data) => dispatch(actions.user.set(data)));
            api.clients.getAll().then((data) => dispatch(actions.clients.set(data)));
            return (
                <DOMRoute path={path} exact={exact}>
                    {showHeader && <Header isPublic={isPublic} showSideNav={showSidenav} />}
                    <props.component />
                    {isPublic && <Footer />}
                </DOMRoute>
            );
        }
    } else {
        return (
            <DOMRoute path={path} exact={exact}>
                {showHeader && <Header isPublic={isPublic} showSideNav={showSidenav} />}
                <props.component />
                {isPublic && <Footer />}
            </DOMRoute>
        );
    }
}

export default Route;
